require('../../reports/_reportTitle');

$(() => {
  $.urlParam = function (name) {
    const results = new RegExp(`[\?&]${name}=([^&#]*)`).exec(window.location.href);
    if (results == null) {
      return null;
    }

    return results[1] || 0;
  };

  let currentListId = null;
  const currentListTitle = null;
  let currentListItemId = null;
  const addToListIds = {};

  $('.select-listEdit').select2({
    placeholder: 'Select a list to edit',
    minimumResultsForSearch: Infinity
  });

  if ($('.select-licenseType').length) {
    $('.time-report').select2({
      placeholder: 'Select Week',
      minimumResultsForSearch: Infinity,
      disabled: true
    });
  } else {
    $('.time-report').select2({
      placeholder: 'Select Week',
      minimumResultsForSearch: Infinity
    });
  }

  $('.select-licenseType').select2({
    placeholder: 'Select License Type',
    minimumResultsForSearch: Infinity
  });

  $('select#graphic_source').select2({
    placeholder: 'Select Graphic Source',
    minimumResultsForSearch: Infinity
  });

  $('.select-licenseType').on('select2:select', function (e) {
    const id = $(this).find('option:selected').val();
    const timeReportSelect = $(this).closest('form').find('.time-report');
    const $this = $(this);

    timeReportSelect.select2('val', '');
    timeReportSelect.select2({
      disabled: true,
      minimumResultsForSearch: Infinity,
      placeholder: 'loading...'
    });

    $.post(loadWeeksUrl, {
      id
    }, (data) => {
      timeReportSelect.find('option').remove();

      $.each(data.weeks, (i, item) => {
        timeReportSelect.append($('<option>', {
          value: i,
          text: item
        }));
      });

      timeReportSelect.select2({
        disabled: false,
        minimumResultsForSearch: Infinity
      });

      $this.trigger('weeks-loaded');
    }, 'json');
  });

  $('.select-listEdit').on('change', function (e) {
    if ($('#lists').children('option').length > 1) {
        	const id = $(this).val();

      $('#search-title').find('button').button('loading');

      $('#search-overlay').show();

      $.post(loadItemsUrl, {
        id
      }, (data) => {
        $('#list-items-cnt').sortable({
          axis: 'y',
          handle: '.sort-handle',
          update() {
            const data = $(this).sortable('serialize');
            $.post(
              reorderListUrl,
              data,
              (data) => {
                if (data.isError == 1) {
                  alert(data.msgError);
                }
              }, 'json'
            );
          }
        });
        $('#search-overlay').hide();

        $('#search-title').find('button').button('reset');

        currentListId = id;

        $('#list-mgmt').show();
        $('#list-items-cnt').html(data.itemsHtml);
        Router.dispatchDomControllers('.search-music-wrapper');
        $('.list-title').html(data.title);
        $('input[name="newTitleList"]').val(data.title);

        if (data.isEmpty == 0) {
          $('.btn-report-all').show();
        } else {
          $('.btn-report-all').hide();
        }

        $('.report-all-ctrl').show();

        if (data.isError) {
          toastr.error(data.msgError, 'Error');
        }
      }, 'json');
    }
  });

  $('#btnDelete').click(() => {
    $.post(deleteListUrl, {
      id: currentListId
    }, (data) => {
      if (data.isError == 1) {
        alert(data.msgError);
      } else {
        $('#deleteListModal').modal('hide');

        $(`#lists option[value="${currentListId}"]`).remove();
        currentListId = $('#lists option:nth-child(2)').attr('value');

        $('.select-listEdit').val(currentListId);
        $('.select-listEdit').trigger('change');

        if (isNaN(currentListId)) {
          currentListId = null;
          $('.report-all-ctrl').hide();
          $('#list-mgmt').hide();
          $('#list-items-cnt').html('<div class="alert alert-info alert-tmp" role="alert">Please, select a list to edit.</div>');
        } else {
          $('.select-listEdit').trigger('select2:select');
        }
      }
    }, 'json');
  });


  $('#search-title').submit(function (e) {
      e.preventDefault();
  });

  $('#listRenameForm').submit(function (e) {
    const form = $(this);
    const dataArr = $(this).serializeArray();

    $(this).find('button').button('loading');

    $.post(renameListUrl, {
      id: currentListId,
      dataArr
    }, (data) => {
      form.find('button').button('reset');
      clearErrors(form);

      const response = data;
      if (response.isError == 1) {
        toastr.error(response.msgError, 'Error');

        if (response.formErrorMessagess && response.formErrorMessagess.length !== 0) {
          $.each(response.formErrorMessagess, (elementId, value) => {
            $.each(value, (index, value) => {
              form.find(`[name="${elementId}"]`).parent().addClass('has-error');
              form.find(`[name="${elementId}"]`).parent().append(`<p for="${elementId}" generated="true" class="help-block">${value}</p>`);
            });
          });
        }
      } else {
        toastr.success('List has been renamed', 'Success');

        $('#renameListModal').modal('hide');

        $('.list-title').html(data.title);
        $('input[name="newTitleList"]').val(data.title);

        $(`#lists option[value="${currentListId}"]`).text(data.title);

        $('.select-listEdit').select2('destroy');
        $('.select-listEdit').select2({
          placeholder: 'Select a list to edit',
          minimumResultsForSearch: Infinity
        });
      }
    });

    e.preventDefault();
  });

  $('#listDuplicateForm').submit(function (e) {
      const form = $(this);
      const dataArr = $(this).serializeArray();

      $(this).find('button').button('loading');

      $.post(duplicateListUrl, {
          id: currentListId,
          dataArr
      }, (data) => {
          form.find('button').button('reset');
          clearErrors(form);

          const response = data;
          if (response.isError == 1) {
              toastr.error(response.msgError, 'Error');

              if (response.formErrorMessagess && response.formErrorMessagess.length !== 0) {
                  $.each(response.formErrorMessagess, (elementId, value) => {
                      $.each(value, (index, value) => {
                        form.find(`[name="${elementId}"]`).parent().addClass('has-error');
                        form.find(`[name="${elementId}"]`).parent().append(`<p for="${elementId}" generated="true" class="help-block">${value}</p>`);
                      });
                  });
              }
          } else {
              toastr.success('List has been duplicated', 'Success');
              form.find('input[name="duplicateListName"]').val('');

              const newList = new Option(response.name, response.id, true, true);
              $('.select-listEdit').append(newList).trigger('change');

              $('#duplicateListModal').modal('hide');
          }
      });

      e.preventDefault();
  });

  $('#listCreateForm').submit(function (e) {
    const form = $(this);
    const dataArr = $(this).serializeArray();

    $(this).find('button').button('loading');

    $.post(urlCreateList, {
      id: currentListId,
      dataArr
    }, (data) => {
      form.find('button').button('reset');
      clearErrors(form);

      const response = data;
      if (response.isError == 1) {
        toastr.error(response.msgError, 'Error');

        if (response.formErrorMessagess && response.formErrorMessagess.length !== 0) {
          $.each(response.formErrorMessagess, (elementId, value) => {
            $.each(value, (index, value) => {
              form.find(`[name="${elementId}"]`).parent().addClass('has-error');
              form.find(`[name="${elementId}"]`).parent().append(`<p for="${elementId}" generated="true" class="help-block">${value}</p>`);
            });
          });
        }
      } else {
        toastr.success('List has been successfully added', 'Success');
        form.find('input[name="list-name"]').val('');

        const newList = new Option(response.name, response.id, true, true);
        $('.select-listEdit').append(newList).trigger('change');
        $('#createListModal').modal('hide');
      }
    });

    e.preventDefault();
  });

  $('#deleteModal').on('show.bs.modal', (e) => {
    const btn = $(e.relatedTarget);

    currentListItemId = btn.data('id-item');
    $('#delete-item-title').html(btn.data('title'));
  });

  $('#createListModal').on('show.bs.modal', (e) => {
    $('.select-listEdit').select2('close');
    clearErrors($('#createListForm'));
  });

  $('#btnDeleteItem').click(function () {
    const btnRfc = $(this);

    btnRfc.button('loading');

    $.post(deleteListItemUrl, {
      id: currentListItemId
    }, (data) => {
      btnRfc.button('reset');

      if (data.isError === 1) {
        alert(data.msgError);
      } else {
        $('.select-listEdit').trigger('change');
        currentListItemId = null;
        $('#deleteModal').modal('hide');
      }
    });
  });

  $('#btnDuplicateCancel').click((e) => {
      $('#duplicateListModal').modal('hide');

      e.preventDefault();
  });

  $('#btnDeleteCancel').click((e) => {
    $('#deleteListModal').modal('hide');

    e.preventDefault();
  });

  $('#btnRenameCancel').click((e) => {
    $('#renameListModal').modal('hide');

    e.preventDefault();
  });

  $('#btnCreateCancel').click((e) => {
    $('#createListModal').modal('hide');

    e.preventDefault();
  });

  $('#process-download').click((e) => {
    if (currentListId != null) {
      $('#downloadAllModal #navigation').hide();
      $('#downloadAllModal #loading').show();
      $('#downloadAllModal').modal('show');

      $.get(`${downloadAllUrl}/${currentListId}`, (data) => {
        if (data.isError === 1) {
          $('#downloadAllModal').modal('hide');
          toastr.error(data.msgError, 'Error');
        } else {
          $('#downloadAllModal #navigation').show();
          $('#downloadAllModal #loading').hide();
        }
      }, 'json');
    }

    e.preventDefault();
  });

  checkIfIdAvailable();

  function checkIfIdAvailable() {
    const id = parseInt($.urlParam('id'));

    if (!isNaN(id)) {
      currentListId = id;

      $('.select-listEdit').val(currentListId);
      $('.select-listEdit').trigger('change');
      $('.select-listEdit').trigger('select2:select');
    }
  }

  function clearErrors(form) {
    form.find('.help-block').remove();
    form.find('.form-group').removeClass('has-error');
  }

  // Auto select after refresh
  if ($('#lists').val()) {
    $('#lists').change();
  }
});
